import React from 'react';
import { FaBars } from 'react-icons/fa';
import userIcon from '../assets/user.png'; // Import the image as a module
import { useNavigate } from 'react-router-dom';

function Navbar({ toggleSidebar }) {
  const navigate = useNavigate(); // Initialize navigate function
  const handleProfileClick = () => {
    navigate('/userinfo'); // Navigate to the profile page
  };

  return (
    <nav className="navbar">
      <div className="navbar-left">
        <span className="icon" onClick={toggleSidebar}>
          <FaBars />
        </span>
        <span className="navbar-logo">OANDA</span>
      </div>
      <div className="navbar-icons">
        <button className="profile-button" onClick={handleProfileClick}>
          <img src={userIcon} alt="Profile" className="profile-icon" />
        </button>
      </div>
    </nav>
  );
}

export default Navbar;